module.exports = __webpack_public_path__ + "static/media/plusItem.921bddb0.svg";